import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import React from 'react';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';

/* global dcAnalytics */
export const FacebookLink = createReactClass({
    propTypes: {
        urlToShare: PropTypes.string.isRequired,
        pageName: PropTypes.string,
        projectId: PropTypes.number,

        getTrackingLink: PropTypes.func.isRequired,
        facebookAppId: PropTypes.string.isRequired,

        onFacebookClick: PropTypes.func.isRequired,
        fulfillmentTrailer: PropTypes.string,
        projectSummary: PropTypes.string,
        useSpan: PropTypes.bool,
        className: PropTypes.string,
        closeAfterShare: PropTypes.bool,
        essentialsListShare: PropTypes.bool,
        delayFun: PropTypes.func,
        clipboardCopyFun: PropTypes.func,

        children: PropTypes.node,
    },

    getDefaultProps: function () {
        return {
            closeAfterShare: false,
        };
    },

    getFacebookUrl: function () {
        const trackingLink = this.props.getTrackingLink(this.props.urlToShare, 'facebook', this.props.pageName);
        return 'https://www.facebook.com/dialog/share?app_id=' + this.props.facebookAppId +
                '&display=popup&href=' + trackingLink + (this.props.closeAfterShare ? '' : '&redirect_uri=' + trackingLink);
    },

    shareIcon: function () {
        if (React.Children.count(this.props.children) > 0) {
            return null;
        } else {
            return (
                <Svg icon="ss-facebook" iconFamily="social-circle"/>
            );
        }
    },

    onClick(event) {
        dcAnalytics.trackShareToolClick(this.props.pageName, this.props.urlToShare, 'Facebook', this.props.essentialsListShare);
        trackShareToolClick(this.props.projectId, SHARE_TOOLS.FACEBOOK);
        if (this.props.clipboardCopyFun && this.props.clipboardCopyFun() != null) {
            navigator.clipboard.writeText(this.props.clipboardCopyFun());
        }
        else if (this.props.fulfillmentTrailer && this.props.projectSummary) {
            const shareText = `${this.props.fulfillmentTrailer}\n\n${this.props.projectSummary}`;
            navigator.clipboard.writeText(shareText);
        }
        const windowFeatures = 'width=500,height=350,resizable=yes,scrollbars=yes,status=yes';

        event.preventDefault();
        const delay = this.props.delayFun ? this.props.delayFun() : 0;
        setTimeout(() => window.open(this.getFacebookUrl(), '_blank', windowFeatures), delay);
        return this.props.onFacebookClick(event, this.getFacebookUrl());
    },

    render: function () {
        if (this.props.useSpan) {
            return (
                <KeyboardClickable>
                    <a className={this.props.className + ' button-secondary  heap-facebook-share'}
                        aria-label="Share on Facebook"
                        data-title="Share on Facebook"
                        target="_blank"
                        onClick={this.onClick}
                        rel="noreferrer"
                        href={this.getFacebookUrl()}>
                        {this.shareIcon()}
                        {this.props.children}
                    </a>
                </KeyboardClickable>
            );
        } else {
            return (
                <a className={this.props.className + ' button-secondary  heap-facebook-share'}
                    aria-label="Share on Facebook"
                    data-title="Share on Facebook"
                    target="_blank"
                    onClick={this.onClick}
                    rel="noreferrer"
                    href={this.getFacebookUrl()}>
                    {this.shareIcon()}
                    {this.props.children}
                </a>
            );
        }
    },
});
